export class HTMLElementUtils {
  public static createSpanRequired(isCheckbox: boolean): HTMLSpanElement {
    const span = document.createElement('span') as HTMLSpanElement;

    span.classList.add('required-asterisk');
    span.textContent = '*';
    span.style.position = 'absolute';
    span.style.top = '-5px';
    span.style.right = '-10px';
    span.style.userSelect = 'none'

    return span;
  }

  public static createInput(fontSize: number): HTMLInputElement {
    const htmlElement = document.createElement('input') as HTMLInputElement;
    htmlElement.setAttribute(
      'style',
      `width: 90%; height: 0.5rem; border: none; font-size: ${fontSize}px;`
    );
    return htmlElement;
  }

  public static createTextArea(fontSize: number): HTMLTextAreaElement {
    const htmlElement = document.createElement('textarea') as HTMLTextAreaElement;
    htmlElement.setAttribute(
      'style',
      `width: 93%; height: 93%; border: none; font-size: ${fontSize}px;`
    );
    return htmlElement;
  }

  public static createCheckbox(): HTMLInputElement {
    const htmlElement = document.createElement('input') as HTMLInputElement;
    htmlElement.type = 'checkbox';
    htmlElement.setAttribute('style', 'width: 100%; height: 100%; border: none;');
    return htmlElement;
  }
}
